import React, { useRef } from 'react';
import { Field, FieldAttributes, ErrorMessage as FormikErrorMessage } from 'formik';
import _ from 'lodash';
import { FormControlProps, ErrorMessage as RsErrorMessage } from 'rsuite';
import Input from './Input';

export interface FormikControlProps extends FormControlProps, FieldAttributes<any> {}

/**
 * 适用于 Formik 的 <FormControl> 组件
 * 跟 RSuite <FormControl> 的 API 一致，但只使用它的样式，不用它原本的功能
 * TODO: error message 用 aria-errormessage 而不是 aria-describedby
 *       这个 pending 在 @testing-library/jest-dom 的 toHaveErrorMessage 上
 *       它要是一直不合 pr 的话也可以考虑自己实现一个
 */
export default function FormControl({
  accepter = Input,
  errorPlacement = 'bottomStart',
  id,
  ...props
}: FormControlProps & FieldAttributes<any>) {
  const idRef = useRef<string>(id);
  idRef.current = idRef.current ?? _.uniqueId('FormikControl');
  return (
    <div className="rs-form-control-wrapper">
      <Field
        component={accepter}
        id={idRef.current}
        aria-describedby={`${idRef.current}-error`}
        {...props}
      />
      <FormikErrorMessage name={props.name}>
        {(message) => (
          <RsErrorMessage role="alert" show placement={errorPlacement} id={`${idRef.current}-error`}>
            {message}
          </RsErrorMessage>
        )}
      </FormikErrorMessage>
    </div>
  );
}
